const CountryExposureTable = require('./CountryExposureTable');

module.exports = CountryExposureTable;
